module.exports = __webpack_public_path__ + "img/bg-brand-video-overlay.90af0cc2.png";